export enum Roles {
	Admin = 1,
	ControlOfficer = 2,
	Receptionist = 3,
	AuthorityRepresentative = 4,
	GeneralDirectorofLegalResearcher = 5,
	DirectorofLegalResearcher = 6,
	HeadofLegalResearcher = 7,
	LegalResearcher = 8,
	GeneralDirectorOfCourtRecords = 9,
	DirectorofCourtRecords = 10,
	CourtRecordsClerk = 11,
	CourtClerk = 12,
	CommitteeMember = 13,
	CommitteeChairman = 14,
	GeneralDirectorOfDecisionPrepartion = 15,
	DirectorofDecisionPrepartion = 16,
	DecisionPrepartionClerk = 17,
	OperationSpecialist = 19,
	TechnicalTeam = 20,
	FollowUpStudyEmployee = 21,
	FollowUpSupervisor = 22,
	DepartmentDirector = 23,
	Minister = 24,
	Prosecutor = 28,
	ProsecutionSupervisor = 29,
	ProsecutionDirector = 30,
}
